import { Gender, TrendingItem } from '@/.gql/graphql';
import { TActualItem } from '@/src/providers';

type HasGenderImages = {
  imageWoman?: string;
  imageMan?: string;
  imageWomanAndMan?: string;
  imageWomanAndWoman?: string;
  imageManAndMan?: string;
  imageManAndWoman?: string;
};

type HasGenderVideos = {
  videoWoman?: string;
  videoMan?: string;
};

type HasGenderPreviews = {
  previewWoman?: string;
  previewMan?: string;
};

type HasGenderGifs = {
  femaleGifUrl?: string;
  maleGifUrl?: string;
  femaleAndFemaleGifUrl?: string;
  femaleAndMaleGifUrl?: string;
  maleAndFemaleGifUrl?: string;
  maleAndMaleGifUrl?: string;
};

export const getImageByGender = (
  item: TActualItem | TrendingItem,
  gender: Gender,
): string | null => {
  if ('imageWoman' in item) {
    const gendered = item as Partial<HasGenderImages>;
    switch (gender) {
      case Gender.Female:
        return gendered.imageWoman ?? null;
      case Gender.Male:
        return gendered.imageMan ?? null;
      case Gender.FemaleAndFemale:
        return gendered.imageWomanAndWoman ?? null;
      case Gender.FemaleAndMale:
        return gendered.imageWomanAndMan ?? null;
      case Gender.MaleAndFemale:
        return gendered.imageManAndWoman ?? null;
      case Gender.MaleAndMale:
        return gendered.imageManAndMan ?? null;
      default:
        return null;
    }
  }

  if ('videoWoman' in item) {
    const gendered = item as Partial<HasGenderVideos>;

    switch (gender) {
      case Gender.Female:
        return gendered.videoWoman ?? null;
      case Gender.Male:
        return gendered.videoMan ?? null;
      default:
        return null;
    }
  }

  if ('previewWoman' in item) {
    const gendered = item as Partial<HasGenderPreviews>;

    switch (gender) {
      case Gender.Female:
        return gendered.previewWoman ?? null;
      case Gender.Male:
        return gendered.previewMan ?? null;
      default:
        return null;
    }
  }

  if ('femaleGifUrl' in item) {
    const gendered = item as Partial<HasGenderGifs>;

    switch (gender) {
      case Gender.Female:
        return gendered.femaleGifUrl ?? null;
      case Gender.Male:
        return gendered.maleGifUrl ?? null;
      case Gender.FemaleAndFemale:
        return gendered.femaleAndFemaleGifUrl ?? null;
      case Gender.FemaleAndMale:
        return gendered.femaleAndMaleGifUrl ?? null;
      case Gender.MaleAndFemale:
        return gendered.maleAndFemaleGifUrl ?? null;
      case Gender.MaleAndMale:
        return gendered.maleAndMaleGifUrl ?? null;

      default:
        return null;
    }
  }

  return null;
};
